<div #WvrDropdown class="wvr-components wvr-dropdown d-inline-flex align-items-center">
  <div ngbDropdown display="{{dropdownMenuDisplay}}" class="d-inline-block">
    <wvr-button-component
      [background]="btnBackground"
      [backgroundActive]="btnBackgroundActive"
      [backgroundHover]="btnBackgroundHover"
      [borderColor]="btnBorderColor"
      [borderActive]="btnBorderActive"
      [borderHover]="btnBorderHover"
      [borderFocus]="btnBorderFocus"
      [borderRadius]="btnBorderRadius"
      [boxShadowFocus]="btnBoxShadowFocus"
      [themeVariant]="themeVariant"
      [btnSize]="btnSize"
      [color]="btnColor"
      [btnType]="btnType"
      [colorActive]="btnColorActive"
      [colorHover]="btnColorHover"
      [cursor]="btnCursor"
      [fontFamily]="btnFontFamily"
      [fontSize]="btnFontSize"
      [fontWeight]="btnFontWeight"
      [href]="btnHref"
      [lineHeight]="btnLineHeight"
      [padding]="btnPadding"
      [role]="role"
      [textAlign]="btnTextAlign"
      [textDecoration]="btnTextDecoration"
      [textDecorationActive]="btnTextDecorationActive"
      [textDecorationFocus]="btnTextDecorationFocus"
      [textDecorationHover]="btnTextDecorationHover"
      [verticalAlign]="btnVerticalAlign" ngbDropdownAnchor>
      <template button-content>
        <ng-content select="template[dropdown-button]"></ng-content>
      </template>
    </wvr-button-component>
    <div ngbDropdownMenu dropdown-menu [ngClass]="{open: open,closed: !open}" class="bg-{{menuThemeVariant}}"></div>
  </div>
</div>

<ng-content select="template[dropdown-menu]"></ng-content>
